import React from "react";

function WorkRecordStatCard({
  title,
  value,
  unit,
  icon,
  color = "text-gray-500",
  bg = "bg-gray-100",
}) {
  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    const num = Number(value);
    if (Number.isNaN(num)) return "-";

    // 0은 "-" 처리 (기존 정책)
    if (num === 0) return "-";

    // 소수점 2자리 반올림 → 문자열
    const fixed = num.toFixed(2);

    // 불필요한 0 제거 (23.80 → 23.8, 3.00 → 3)
    return fixed.replace(/\.?0+$/, "");
  };

  const displayValue = formatValue(value);

  return (
    <div className="bg-white rounded-[28px] p-5 shadow-sm border border-gray-100 flex flex-col items-center">
      {/* 아이콘 */}
      <div
        className={`w-11 h-11 ${bg} ${color} rounded-2xl flex items-center justify-center mb-3`}
      >
        {React.cloneElement(icon, { className: "w-5 h-5" })}
      </div>

      {/* 타이틀 */}
      <p className="text-[10px] font-black text-gray-400 uppercase mb-1 tracking-tight">
        {title}
      </p>

      {/* 값 */}
      <p className="text-xl font-bold text-gray-800 leading-none">
        {displayValue}
        <span className="text-[12px] text-gray-300 font-bold ml-1">{unit}</span>
      </p>
    </div>
  );
}

export default WorkRecordStatCard;
